<template>
  <div>
    <pop-modal ref="popModal" :visible="visible" :isDrag="true" title="申领状态查询" width="70%" :height="80" @cancel="handelCancel">
      <div class="header">
        <div class="select">
          <div>
            <div>
              <span class="mr-1">申请时间起</span
              ><a-date-picker v-model="applyParam.startDate" @change="startChange" /><input
                type="checkbox"
                class="ml-1"
                v-model="startChecked"
              />
            </div>
            <div>
              <span class="mr-1">申请时间止</span
              ><a-date-picker v-model="applyParam.endDate" @change="endChange" /><input
                type="checkbox"
                class="ml-1"
                v-model="endChecked"
              />
            </div>
          </div>
          <div>
            <div>
              <span class="mr-1">发票种类</span>
              <a-select v-model="applyParam.taxClass" style="width: 150px">
                <a-select-option value=""> 全部 </a-select-option>
                <a-select-option value="0"> 专用发票 </a-select-option>
                <a-select-option value="1"> 普通发票 </a-select-option>
                <a-select-option value="3"> 电子普通发票 </a-select-option>
              </a-select>
            </div>
            <div>
              <span class="mr-1">申领状态</span>
              <a-select v-model="applyParam.status" style="width: 150px">
                <a-select-option value=""> 全部 </a-select-option>
                <a-select-option value="1"> 成功 </a-select-option>
                <a-select-option value="9"> 失败 </a-select-option>
                <a-select-option value="0"> 申领 </a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="btn">
          <a-button type="primary" ghost class="mr-1" @click="searchInvoiceByStatus()"> 查询 </a-button>
          <a-button type="primary" ghost class="mr-1" @click="$refs.OnlineApplyForm.show()"> 申领 </a-button>
        </div>
      </div>
      <m-table
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :data-source="sourceData"
      >
        <template #operation>
          <a-button @click="applyDetail()">明细</a-button>
          <a-button @click="applyConfirm()">确认</a-button>
          <a-button @click="applyDismiss()">撤销</a-button>
        </template>
      </m-table>
    </pop-modal>
    <pop-modal :visible="optionShow" :isDrag="true" title="操作" width="400px" :height="50" @cancel="optionShow = false">
      <m-table
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="detailedColumns"
        :data-source="applyDetailList"
      >
      </m-table>
      <div class="foot-btn">
        <a-button type="primary" ghost @click="submitDetail()"> 确定 </a-button>
      </div>
    </pop-modal>
    <online-apply ref="OnlineApplyForm"></online-apply>
  </div>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam } from '@/utils/util'
import OnlineApply from './OnlineApply.vue'
import moment from 'moment'
import 'moment/locale/zh-cn'

export default {
  components: {
    OnlineApply,
  },
  data() {
    return {
      visible: false,
      pagination: false,
      selectedRowKeys: [],
      columns: [
        {
          title: '预申请编号',
          dataIndex: '',
          width: 100,
        },
        {
          title: '发票种类',
          dataIndex: 'taxClass',
          width: 100,
          customRender: (v) => (v === 0 ? '增值税专用发票' : v === 1 ? '增值税普通发票' : '普通电子发票'),
        },
        {
          title: '申领数量',
          dataIndex: 'taxBillBuyNum',
          width: 100,
        },
        {
          title: '申领结果',
          dataIndex: '',
          width: 100,
          customRender: (v) => (v === 0 ? '申领待确认' : v === 1 ? '网上申领成功' : '申领已撤销'),
        },
        {
          title: '处理信息',
          dataIndex: '',
          width: 100,
        },
        {
          title: '申请时间',
          dataIndex: 'taxBillBuyDate',
          width: 100,
          customRender: (v) => moment(v).format('YYYY-MM-DD'),
        },
        {
          title: '纸票确认',
          dataIndex: '',
          width: 100,
        },
        {
          title: '操作',
          dataIndex: '',
          width: 200,
          scopedSlots: { customRender: 'operation' },
        },
      ],
      sourceData: [],
      applyParam: {
        taxClass: '',
        status: '',
        startDate: moment(),
        endDate: moment(),
      },
      startChecked: false,
      endChecked: false,
      // 操作弹窗
      optionShow: false,
      detailedColumns: [
        {
          title: '发票代码',
          dataIndex: 'taxBillCode',
        },
        {
          title: '起始号码',
          dataIndex: 'taxBillNoStart',
        },
        {
          title: '终止号码',
          dataIndex: 'taxBillNoEnd',
        },
        {
          title: '份数(本/卷)',
          dataIndex: 'taxBillBuyNum',
        },
      ],
      applyDetailList: [],
    }
  },
  methods: {
    show() {
      this.visible = true
      this.searchInvoiceByStatus()
    },
    /**
     * 申领状态查询
     */
    async searchInvoiceByStatus() {
      const params = parseParam({
        taxClass: this.applyParam.taxClass,
        status: this.applyParam.status,
        startDate: this.startChecked ? this.applyParam.startDate.format('YYYY-MM-DD HH:mm:ss') : '',
        endDate: this.endChecked ? this.applyParam.endDate.format('YYYY-MM-DD HH:mm:ss') : '',
      })
      const res = await this.$http.post(`${Urls.applyList}&${params}`)
      if (res.statusCode === '200') {
        this.sourceData = res.data
      } else {
        this.$message.warning(res.msg)
      }
    },
    startChange(date, dateString) {
      this.applyParam.startDate = date
    },
    endChange(date, dateString) {
      this.applyParam.endDate = date
    },
    handelCancel() {
      this.visible = false
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.drID = this.selectedRowKeys[0].id
    },
    // 申领撤销
    async applyDismiss() {
      const params = parseParam({
        id: this.selectedRowKeys[0].id,
      })
      const res = await this.$http.post(`${Urls.applyDismiss}&${params}`)
      if (res) {
        this.$success({
          title: '提示',
          content: '撤销申领成功!',
        })
        this.searchInvoiceByStatus()
      }
    },
    // 申领确认
    async applyConfirm() {
      const params = parseParam({
        id: this.selectedRowKeys[0].id,
      })
      const res = await this.$http.post(`${Urls.applyConfirm}&${params}`)
      if (res) {
        this.$success({
          title: '提示',
          content: '申领成功!',
        })
        this.searchInvoiceByStatus()
      }
    },
    // 申领明细
    async applyDetail() {
      this.optionShow = true
      const params = parseParam()
      const res = await this.$http.post(`${Urls.applyDismissList}&${params}`)
      if (res) {
        this.applyDetailList = res.data
      }
    },
    // 申领明细确认
    async submitDetail() {
      const params = parseParam()
      const res = await this.$http.post(`${Urls.applyConfirmList}&${params}`)
      if (res) {
        this.searchInvoiceByStatus()
      }
      this.optionShow = false
    },
  },
}
</script>

<style lang="less" scoped>
.ml-1 {
  margin-left: 5px;
}
.mr-1 {
  margin-right: 5px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  .select {
    display: flex;
    flex: 1;
    justify-content: space-around;
    > div {
      display: flex;
      flex-direction: column;
      margin-right: 10px;
      > div {
        padding: 10px 0;
      }
    }
  }
  .btn {
    justify-content: space-between;
  }
}
.foot-btn {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 14px;
}
</style>
